class EstrazioneMenu {
  constructor(section) {
    this.section = section;
    this.menuItems = section.querySelectorAll('.estrazione__menu-item');
    this.guide = section.querySelectorAll('.estrazione__guida');
    
    this.init();
  }
  
  init() {
    this.menuItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const guidaName = e.currentTarget.getAttribute('data-guida');
        if (guidaName) {
          this.switchGuida(guidaName);
        }
      });
    });
  }
  
  switchGuida(guidaName) {
    // Rimuovi active da tutti i menu items
    this.menuItems.forEach(item => {
      item.classList.remove('active');
    });
    
    // Rimuovi active da tutte le guide
    this.guide.forEach(guida => {
      guida.classList.remove('active');
    });
    
    // Aggiungi active al menu item selezionato
    const selectedMenuItem = this.section.querySelector(`.estrazione__menu-item[data-guida="${guidaName}"]`);
    if (selectedMenuItem) {
      selectedMenuItem.classList.add('active');
    }
    
    // Aggiungi active alla guida corrispondente
    const selectedGuida = this.section.querySelector(`.estrazione__guida[data-guida="${guidaName}"]`);
    if (selectedGuida) {
      selectedGuida.classList.add('active');
    }
  }
}

// Inizializza quando il DOM è pronto
document.addEventListener('DOMContentLoaded', () => {
  const estrazioneSections = document.querySelectorAll('.estrazione-section');
  estrazioneSections.forEach(section => {
    new EstrazioneMenu(section);
  });
});

